import { styled } from '../../../../configs/stitches.config';

export const ModalOverlay = styled('div', {
  alignItems: 'center',
  backgroundColor: 'rgba(15, 23, 42, 0.4)',
  display: 'flex',
  inset: 0,
  justifyContent: 'center',
  padding: '$spacingMd',
  position: 'fixed',
  zIndex: 1000,
});

export const ModalContent = styled('div', {
  backgroundColor: '$backgroundPrimary',
  borderRadius: '12px',
  boxShadow: '$shadowBase',
  maxHeight: 'calc(100vh - 48px)',
  maxWidth: '720px',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  zIndex: 1001,
});

export const ModalHeader = styled('div', {
  borderBottom: '1px solid $borderColorLight',
  padding: '$spacingXl $spacingXl $spacingLg',
});

export const ModalTitle = styled('h2', {
  color: '$textColorPrimary',
  fontSize: '1.1rem',
  fontWeight: 700,
  margin: 0,
});

export const ModalDescription = styled('p', {
  color: '$textColorSecondary',
  fontSize: '0.9rem',
  lineHeight: 1.5,
  margin: '$spacingSm 0 0',
});

export const CloseButton = styled('button', {
  alignItems: 'center',
  backgroundColor: 'transparent',
  border: 'none',
  color: '$textColorSecondary',
  cursor: 'pointer',
  display: 'inline-flex',
  fontSize: '1.45rem',
  height: '32px',
  justifyContent: 'center',
  lineHeight: 1,
  padding: 0,
  position: 'absolute',
  right: '$spacingMd',
  top: '$spacingMd',
  width: '32px',

  '&:hover': {
    color: '$textColorPrimary',
  },
});

export const AdjustmentDate = styled('p', {
  font: '$captionRegular',
  marginBottom: '$spacingMd',
});

export const BoldText = styled('p', {
  font: '$labelBold',
});

export const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$spacingSm',
});

export const ModalContentWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100vh - 220px)',
  overflowY: 'auto',
  padding: '$spacingLg $spacingXl $spacingXl',
});

export const Row = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
});

export const Text = styled('p', {
  font: '$labelRegular',
});

export const Title = styled('p', {
  font: '$bodyBold',
});
